export const LOCK_CLAIM = 'LOCK_CLAIM';
export const LOCK_RELEASE = 'LOCK_RELEASE';

export const LOCK_REDUCER_SLICE_NAME = 'lock';

export const LOCK_VIEW_TYPE_PAGE = 'page';
export const LOCK_VIEW_TYPE_THEME = 'theme';